import { Button, Form, Radio } from "antd";
import { Input } from "antd";
import { Empty } from "antd";
import { Table } from "antd";
import { Select } from "antd";
import { Col, Row } from "antd";
import React, { FC, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/store";

const { Option } = Select;
const { Search } = Input;

type DiagnosticDataProps = {
  form: any;
  diagnosisData: any;
  newDiagnosis: any;
  setNewDiagnosis: any;
  diagnosisOptions: any;
  handleCategorySearch: any;
  handleDiagnosisSelect: any;
  handleAddDiagnosis: any;
  disabledForm: any;
  DiagonsisColumns: any;
};

const DiagnosticData: FC<DiagnosticDataProps> = ({
  form,
  diagnosisData,
  newDiagnosis,
  setNewDiagnosis,
  diagnosisOptions,
  handleCategorySearch,
  handleDiagnosisSelect,
  handleAddDiagnosis,
  disabledForm,
  DiagonsisColumns,
}) => {
  const [searchText, setSearchText] = useState("");
  const { patients } = useSelector((state: RootState) => state);

  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "18px",
          marginBottom: "6px",
          fontWeight: "bold",
        }}
      >
        DIAGNOSIS
      </div>

      <Form form={form} layout="vertical" style={{ margin: "16px 0" }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={14} lg={14} xl={14}>
            <Form.Item label="SEARCH DIAGNOSIS">
              {/* <Search
                placeholder="Type here"
                // loading={ayushBPreAuth?.isFetchingData}
                onSearch={(value) => handleCategorySearch(value)}
                disabled={disabledForm}
              /> */}

              <Select
                showSearch
                placeholder="Select a Diagnosis"
                style={{ width: "100%" }}
                value={
                  newDiagnosis?.diagnosisCode !== "" &&
                  newDiagnosis?.diagnosisCode
                    ? newDiagnosis?.diagnosisCode
                    : null
                }
                onChange={handleDiagnosisSelect}
                // onSearch={(value) => handleCategorySearch(value)}
                onSearch={(value) => {
                  setSearchText(value);
                  handleCategorySearch(value);
                }}
                // onSearch={handleCategorySearch}
                disabled={disabledForm}
                filterOption={false}
                notFoundContent={
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={
                      !searchText
                        ? "Please type to search diagnosis"
                        : "No diagnosis found"
                    }
                  />
                }
                // filterOption={(input, option) =>
                //   (option?.label as string)
                //     ?.toLowerCase()
                //     .includes(input.toLowerCase()) ||
                //   (option?.value as string)
                //     ?.toLowerCase()
                //     .includes(input.toLowerCase()) ||
                //   (option?.data?.diagnosisCode as string)
                //     ?.toLowerCase()
                //     .includes(input.toLowerCase())
                // }
              >
                {diagnosisOptions?.map((option: any, index: any) => {
                  const fullText = `${option?.diagnosisDescription} | (${option?.diagnosisCode})`;
                  return (
                    <Option
                      key={index}
                      value={option?.diagnosisCode}
                      label={fullText}
                      data={option}
                    >
                      {fullText}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>

          {/* <Col xs={24} sm={12} md={7} lg={7} xl={7}>
            <Form.Item label="SELECT DIAGNOSIS" name="selectedDiagnosis">
              <Select
                showSearch
                placeholder="Select"
                style={{ width: "100%" }}
                value={
                  newDiagnosis?.diagnosisCode !== "" &&
                  newDiagnosis?.diagnosisCode
                    ? newDiagnosis?.diagnosisCode
                    : null
                }
                onChange={handleDiagnosisSelect}
                disabled={!(diagnosisOptions?.length > 0) || disabledForm}
                filterOption={false}
                // filterOption={(input, option) =>
                //   (option?.label as string)
                //     ?.toLowerCase()
                //     .includes(input.toLowerCase()) ||
                //   (option?.value as string)
                //     ?.toLowerCase()
                //     .includes(input.toLowerCase()) ||
                //   (option?.data?.diagnosisCode as string)
                //     ?.toLowerCase()
                //     .includes(input.toLowerCase())
                // }
              >
                {diagnosisOptions?.map((option: any, index: any) => {
                  const fullText = `${option?.diagnosisDescription} | (${option?.diagnosisCode})`;
                  return (
                    <Option
                      key={index}
                      value={option?.diagnosisCode}
                      label={fullText}
                      data={option}
                    >
                      {fullText}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col> */}
          <Col xs={24} sm={12} md={7} lg={7} xl={7}>
            <Form.Item
              label="DIAGNOSIS TYPE"
              name="diagnosisType"
              //   rules={[
              //     { required: true, message: "Please select diagnosis type" },
              //   ]}
            >
              <Radio.Group
                value={newDiagnosis?.type || null}
                onChange={(e) =>
                  setNewDiagnosis((prev: any) => ({
                    ...prev,
                    type: e.target.value,
                  }))
                }
                disabled={disabledForm}
              >
                {!diagnosisData?.some(
                  (item: any) => item?.type == "Primary",
                ) && <Radio value="Primary">Primary</Radio>}
                <Radio value="Secondary">Secondary</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          {false ? (
            <></>
          ) : (
            <Col span={2} style={{ display: "flex", alignItems: "center" }}>
              <Button
                style={{
                  width: "100px",
                  color: "white",
                  backgroundColor: "rgb(0, 84, 157)",
                }}
                onClick={handleAddDiagnosis}
                disabled={
                  !newDiagnosis.diagnosis || !newDiagnosis.type || disabledForm
                }
              >
                ADD
              </Button>
            </Col>
          )}
          <Table
            dataSource={diagnosisData?.length ? diagnosisData : []}
            columns={DiagonsisColumns}
            pagination={false}
            className="claim-table"
            locale={{ emptyText: null }}
            bordered
            style={{
              width: "100%",
              // margin: "10px auto",
              textAlign: "center",
            }}
          />
        </Row>
      </Form>
    </div>
  );
};

export default DiagnosticData;
